<div class="landing-title" [class.is-medium]="isMediumSize" [class.is-black]="isBlack"
     [class.is-bold]="isBold" [class.fw-semibold]="isSemiBold"
     [class.justify-content-between]="spaceBetweenTitleAndTrailing">
  <span>
    {{ title }}
  </span>
  <ng-content></ng-content>
</div>
